import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Colors } from '../styles';
import { Eye } from './icons/eye';
export const CompactDailyTaskCard = ({ label, currentValue, goalValue, unit, iconSlot, isAchieved, actionLabel, onClick, isValueInactive, isSample, classObject, isHidden, onToggleVisibility, }) => {
    const valueText = isHidden || isSample || currentValue == null ? '--' : currentValue.toLocaleString();
    const unitText = isSample
        ? goalValue != null || unit === 'kcal' || unit === '歩'
            ? `/ --${unit}`
            : unit
        : goalValue != null
            ? `/ ${goalValue.toLocaleString()} ${unit}`
            : unit;
    const handleClickEye = (e) => {
        if (!onToggleVisibility)
            return;
        e.stopPropagation();
        onToggleVisibility();
    };
    return (React.createElement("div", { className: css(classObject, styles.container, isAchieved ? styles.achievedBorder : styles.defaultBorder, onClick && styles.clickable), onClick: onClick },
        React.createElement("div", { className: css(styles.header) },
            iconSlot,
            React.createElement("span", { className: css(styles.label) }, label)),
        actionLabel ? (React.createElement("div", { className: css(styles.actionWrapper) },
            React.createElement("span", { className: css(styles.actionButton) }, actionLabel))) : (React.createElement("div", { className: css(styles.valueBlock) },
            React.createElement("span", { className: css(styles.value, isValueInactive && styles.valueInactive) }, valueText),
            React.createElement("span", { className: css(styles.unit) }, unitText))),
        onToggleVisibility && (React.createElement(Eye, { close: isHidden, color: Colors.GrayDarkest, classObject: styles.eyeWrap, onClick: handleClickEye }))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        padding: '10px 4px',
        backgroundColor: Colors.White,
        borderRadius: 14,
        borderStyle: 'solid',
        borderWidth: 2,
    },
    defaultBorder: {
        borderColor: Colors.BorderLightGray,
    },
    achievedBorder: {
        borderColor: Colors.ProgressGreen,
    },
    clickable: {
        cursor: 'pointer',
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
    },
    label: {
        fontWeight: 'bold',
        fontSize: 14,
        lineHeight: 1,
        color: Colors.Black,
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    eyeWrap: {
        position: 'absolute',
        right: 4,
        bottom: 10,
        cursor: 'pointer',
    },
    valueBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        whiteSpace: 'nowrap',
    },
    value: {
        fontWeight: 'bold',
        fontSize: 16,
        color: Colors.Black,
        textAlign: 'center',
    },
    valueInactive: {
        color: Colors.GrayDarkest,
    },
    unit: {
        fontWeight: 'bold',
        fontSize: 10,
        color: Colors.GrayDarkest,
        textAlign: 'center',
    },
    actionWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
    },
    actionButton: {
        backgroundColor: Colors.PrimaryDark,
        color: Colors.White,
        fontWeight: 'bold',
        fontSize: 12,
        lineHeight: 1.4,
        padding: '7px 10px 8px',
        borderRadius: 17,
    },
});
